<!-- Single select: OneVedAI select. Multi-select: checkbox list (the library select has no multiple mode). -->
@if (control) {
  @if (multiple) {
    <div class="multi" role="group">
      @if (label) {
        <span class="multi-label">{{ label }} @if (required) {<span class="required-asterisk">*</span>}</span>
      }
      @for (option of options; track option.value) {
        <label class="multi-item">
          <onevedai-checkbox [checked]="isChecked(option.value)" [disabled]="isDisabled || !!option.disabled" (checkedChange)="toggle(option.value, $event)"></onevedai-checkbox>
          <span>{{ option.label }}</span>
        </label>
      }
      @if (isInvalid) {
        <span class="multi-error">{{ displayError }}</span>
      } @else if (hint) {
        <span class="multi-hint">{{ hint }}</span>
      }
    </div>
  } @else {
    <onevedai-select
      [label]="required && label ? label + ' *' : label"
      [placeholder]="'Select an option'"
      [value]="stringValue"
      [disabled]="isDisabled"
      [invalid]="isInvalid"
      [errorMessage]="displayError"
      [hint]="hint"
      (valueChange)="onLibraryChange($event)"
      (focusin)="onFocus()"
      (focusout)="onBlur()"
    >
      @for (option of options; track option.value) {
        <onevedai-option [value]="'' + option.value" [disabled]="!!option.disabled">{{ option.label }}</onevedai-option>
      }
    </onevedai-select>
  }
}
